import { useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    selectIntentSelectedTopics,
    selectIsSelectedTopicFetching,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";

export const IntentSignalTypeSectionMeta = () => {
    const { translate } = useTranslate();
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const isSelectedTopicsFetching = useSelector(selectIsSelectedTopicFetching);

    if (!salesSettingsHelper.isIntentSignalsEnabled() || isSelectedTopicsFetching) {
        return null;
    }

    const numIntentTopics = salesSettingsHelper.getNumIntentTopics();

    return (
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[250]}
        >
            {translate("si.intent.management.selected-topics")}:{selectedTopics.length}/{numIntentTopics}
        </Text>
    );
};
